<ng-container *ngIf="getComponentRenderState() === 'content'">
  <ng-container *ngIf="loyaltyProgram">
    <h1
      class="loyalty-program-logo-image-container rounded-md-t mx-auto mt-5 mb-6 flex px-4 lg:mb-8">
      <img
        class="loyalty-program-logo-image"
        [src]="loyaltyProgram.pointsTransferCapability.logoUrl"
        [alt]="loyaltyProgram.name" />
    </h1>

    <ul
      class="loyalty-program-terms-list rounded-md-b mb-0 mt-0 px-4 py-4"
      [attr.aria-label]="
        'accessibility.transfer_v2.program_details'
          | translate: { loyaltyProgramName: loyaltyProgram.name }
      ">
      <li class="loyalty-program-terms-list-item">
        <rd-shared-icon
          class="mt-1 h-4 w-4"
          [iconSymbol]="'icon-convert-points'"
          [iconTheme]="'primary'"
          [iconOptions]="flippableIconOptions"></rd-shared-icon>
        <span
          class="loyalty-program-terms-list-item-text mb-2 ltr:ml-3 rtl:mr-3"
          [innerHTML]="
            ('app.points_with_points_currency'
              | translate: sourceAmountTranslationParams()) +
            '&nbsp;=&nbsp;' +
            ('app.points_with_points_currency'
              | translate: destinationAmountTranslationParams())
          ">
        </span>
      </li>

      <li class="loyalty-program-terms-list-item">
        <rd-shared-icon
          class="mt-1 h-4 w-4"
          [iconSymbol]="'icon-clock'"
          [iconTheme]="'primary'"></rd-shared-icon>
        <span
          class="loyalty-program-terms-list-item-text mb-2 ltr:ml-3 rtl:mr-3">
          {{
            'transfer_v2.checkout.transfer_time'
              | translate: estimatedTransferTimeParams()
          }}
        </span>
      </li>

      <li class="loyalty-program-terms-list-item">
        <rd-shared-icon
          class="mt-1 h-4 w-4"
          [iconSymbol]="'icon-minimum-transfer'"
          [iconTheme]="'primary'"
          [iconOptions]="flippableIconOptions"></rd-shared-icon>
        <span
          class="loyalty-program-terms-list-item-text mb-0 ltr:ml-3 rtl:mr-3">
          {{
            'transfer_v2.checkout.minimum_transfer'
              | translate: minimumPointsTransferTranslationParams()
          }}
        </span>
      </li>
    </ul>
  </ng-container>
</ng-container>

<ng-container *ngIf="getComponentRenderState() === 'loading'">
  <div
    class="loyalty-program-logo-image-loading rounded-md mx-auto my-6 mt-8"></div>

  <ul class="loyalty-program-terms-list loading m-0 p-0">
    <li
      *ngFor="let loadingTermsList of [0, 1, 2]"
      class="loyalty-program-terms-list-item loading mb-4 ltr:ml-4 rtl:mr-4"></li>
  </ul>
</ng-container>
